import { COGNITO_ADMIN, COGNITO_GPS_EDIT_ADMIN, COGNITO_USER } from 'config'
import { useAuth } from 'react-oidc-context'

export default function useUserRole() {
  const auth = useAuth()

  const rawGroups = auth.user?.profile?.['cognito:groups']

  const getUserGroups = (groups) => {
    if (Array.isArray(groups)) {
      return groups
    } else if (groups) {
      return [groups]
    }
    return []
  }

  const userGroups = getUserGroups(rawGroups)

  return {
    isAdmin: userGroups.some((g) => g.endsWith(COGNITO_ADMIN)),
    isGpsEditor: userGroups.some((g) => g.endsWith(COGNITO_USER)),
    isAdminCourseEditor: userGroups.some((g) => g.endsWith(COGNITO_GPS_EDIT_ADMIN)),
    isLoading: auth.isLoading,
  }
}
